import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

/**
 * Mounts tab content on first visit and keeps it mounted (display toggled)
 * so switching inventory tabs does not refetch data or rebuild heavy tables.
 */
function InventoryTabPanel({ active, children }) {
  const [mounted, setMounted] = useState(active);

  useEffect(() => {
    if (active) setMounted(true);
  }, [active]);

  if (!mounted) return null;

  return (
    <Box
      sx={{ display: active ? 'block' : 'none' }}
      aria-hidden={!active}
      hidden={!active}
    >
      {children}
    </Box>
  );
}

export default InventoryTabPanel;
